module.exports = __webpack_public_path__ + "static/media/TwoWay.34ff7748.pdf";